module.exports = __webpack_public_path__ + "img/android-chrome-maskable-192x192.845a3947.png";